import React, { useContext } from 'react';
import Paragraph from "@scentregroup/ui/components/paragraph";
import { FeatureFlagsContext } from '../../context';
import { jsx as _jsx } from "react/jsx-runtime";
const EventNotification = _ref => {
  let {
    className,
    message = '*Upcoming events are subject to change'
  } = _ref;
  const IS_EVENT_NOTY = useContext(FeatureFlagsContext).NEXT_PUBLIC_FEAT_FLAG_EVENT_NOTY;
  if (IS_EVENT_NOTY) {
    return /*#__PURE__*/_jsx(Paragraph, {
      type: "large",
      className: className,
      "data-id": "event-notification_index_EventNotification_Paragraph",
      children: message
    });
  }
  return null;
};
export default EventNotification;